import HashMap from "hashmap";

// --------------- Main API Response handler

export const newAPIResponseHandler = (response, next) => {
  if (response.status >= 200 && response.status < 300) {
    if (response?.data?.statusCode === 200) {
      next &&
        next(
          response?.data?.responseData
            ? response?.data?.responseData
            : response?.data?.message
        );
    } else if (
      response?.data?.statusCode === 204 &&
      response?.data?.responseData
    ) {
      next && next(response?.data?.responseData);
    } else {
      next && next(null, response?.data?.message);
    }
  } else {
    next && next(null, errorHandlerHelper(response));
  }
};

// ----------------- Error handler function

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const errorHandlerHelper = (err) => {
  let result = "Internal Server Error";
  if (err?.response) {
    switch (err?.response?.status) {
      case 400:
      case 404:
      case 500:
        if (err?.response?.data?.message) {
          return (result = err?.response?.data?.message);
        } else if (typeof err?.response?.data === "object") {
          map = objToStrMap(JSON.parse(JSON.stringify(err?.response?.data)));
          map.forEach((ele) => (err = ele));
          return (result = err);
        } else if (typeof err?.response?.data === "string") {
          return (result = err?.response?.data);
        }
        break;
      default:
        result = "Unknown Error";
        break;
    }
  }
  return result;
};
